import { type FirebaseApp, getApp, getApps, initializeApp } from "firebase/app";
import { type Auth, getAuth } from "firebase/auth";

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
};

export const firebaseReady: boolean = Boolean(
  config.apiKey && config.authDomain && config.projectId,
);

function getFirebaseApp(): FirebaseApp {
  if (!firebaseReady) {
    throw new Error(
      "Firebase Web SDK no configurado. Falta VITE_FIREBASE_API_KEY / VITE_FIREBASE_AUTH_DOMAIN / VITE_FIREBASE_PROJECT_ID en .env. Si cambiaste .env recién, reiniciá `pnpm dev`.",
    );
  }
  return getApps().length === 0 ? initializeApp(config) : getApp();
}

export function getFirebaseAuth(): Auth {
  return getAuth(getFirebaseApp());
}
